import { cx } from "class-variance-authority";
import clsx from "clsx";
import { Button as AriaButton, Label as AriaLabel } from "react-aria-components";

import { InfoIcon } from "@/assets/icons/general/Info";
import { Tooltip } from "@/components/ui/overlays/Tooltip/Tooltip";
import { Typography } from "@/components/ui/text/Typography/Typography";

export type InputHeaderProps = {
  label: string;
  tooltipText?: string;
  helperText?: string;
  required?: boolean;
  rightContent?: React.ReactNode;
  hideLabels?: boolean;
  // oxlint-disable-next-line react/no-unused-prop-types
  hideLabel?: boolean;
  loginLabel?: boolean;
  className?: string;
};

export const InputHeader = ({
  label,
  tooltipText,
  helperText,
  required,
  rightContent,
  hideLabels,
  loginLabel,
  className,
}: InputHeaderProps) => {
  return (
    <div className={clsx("mb-1", hideLabels && "hidden", className)}>
      <div className="flex items-start justify-between">
        <div>
          <div className="flex items-start gap-1">
            <AriaLabel className="flex items-start">
              <Typography
                as="span"
                size="label-2"
                variant="prominent-2"
                className={cx(
                  "font-labels-prominent-2 text-label-5 text-text-default-tertiary",
                  loginLabel && "!text-interactive-primary-disabled",
                  className,
                )}
              >
                {label}
              </Typography>

              {required && (
                <Typography
                  as="span"
                  size="label-2"
                  variant="prominent-1"
                  className={cx(
                    "ml-0-5 text-info-error text-label-5",
                    loginLabel && "!text-interactive-primary-disabled",
                  )}
                >
                  *
                </Typography>
              )}
            </AriaLabel>

            {tooltipText && (
              <Tooltip text={tooltipText}>
                {/* needs to be a button; tooltips are not allowed on unfocusable elements */}
                <AriaButton>
                  <InfoIcon
                    className="h-6 w-6 text-interactive-icon-idle"
                    tabIndex={0}
                  />
                </AriaButton>
              </Tooltip>
            )}
          </div>
        </div>
        {rightContent}
      </div>

      {helperText && (
        <Typography
          slot="description"
          size="label-2"
          className="text-text-default-secondary"
        >
          {helperText}
        </Typography>
      )}
    </div>
  );
};
